import React from "react";

const Arrow = () => {
	return(
		<svg xmlns="http://www.w3.org/2000/svg" width="6" height="50" viewBox="0 0 6 50" fill="none">
			<path d="M3 50L5.88675 45L0.113247 45L3 50ZM2.5 -2.18557e-08L2.5 45.5L3.5 45.5L3.5 2.18557e-08L2.5 -2.18557e-08Z" fill="#7AB1D5"/>
		</svg>
	);
};

export default Arrow;
